import { useEffect, useMemo, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Mail, Activity, FileText } from "lucide-react";
import EmailEventsPanel from "@/components/admin-emails/EmailEventsPanel";
import EmailTemplatesPanel from "@/components/admin-emails/EmailTemplatesPanel";
import api from "@/lib/api";

export default function AdminEmailsPage() {
  const [companies, setCompanies] = useState([]);
  const [me, setMe] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [c, m] = await Promise.all([
          api.get("/companies"),
          api.get("/auth/me"),
        ]);
        setCompanies(c.data || []);
        setMe(m.data || null);
      } catch { /* silencioso */ }
    })();
  }, []);

  const isMaster = me?.role === "master";
  const allowedCompanies = useMemo(() => {
    if (isMaster) return companies;
    const cids = me?.company_ids || [];
    return companies.filter(c => cids.includes(c.id));
  }, [companies, me, isMaster]);

  return (
    <div className="space-y-6" data-testid="admin-emails-page">
      <header className="flex items-start justify-between gap-6">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-xl bg-[#C5A05915] border border-[#C5A05940] flex items-center justify-center">
              <Mail className="w-5 h-5 text-[#C5A059]" />
            </div>
            <div>
              <h1 className="font-display text-3xl md:text-[34px] font-semibold tracking-tight">
                Notificações por E-mail
              </h1>
              <p className="text-sm text-[#AAB4A8] mt-1">
                Monitoramento de envios e configuração dos modelos transacionais
              </p>
            </div>
          </div>
        </div>
      </header>

      <Tabs defaultValue="health" className="w-full">
        <TabsList className="bg-[#1A231F] border border-[#2C3A2F]">
          <TabsTrigger value="health" data-testid="admin-emails-tab-health" className="data-[state=active]:bg-[#C5A05920] data-[state=active]:text-[#C5A059]">
            <Activity className="w-4 h-4 mr-2" /> Health Check
          </TabsTrigger>
          <TabsTrigger value="templates" data-testid="admin-emails-tab-templates" className="data-[state=active]:bg-[#C5A05920] data-[state=active]:text-[#C5A059]">
            <FileText className="w-4 h-4 mr-2" /> Modelos
          </TabsTrigger>
        </TabsList>
        <TabsContent value="health" className="mt-6">
          <EmailEventsPanel companies={allowedCompanies} isMaster={isMaster} />
        </TabsContent>
        <TabsContent value="templates" className="mt-6">
          <EmailTemplatesPanel companies={allowedCompanies} isMaster={isMaster} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
